import { FormFieldValueTypeEnum } from "../_common/enum/forms/formFieldValueType.enum";

const CONTACT_PHONE_SPECIAL_TYPE = 8;

export function isPhoneField(field: { formFieldValueTypeId?: FormFieldValueTypeEnum | "" | number; formFieldKeySpecialTypeId?: number; shortName?: string; label?: string }) {
    const name = `${field.shortName ?? ""} ${field.label ?? ""}`.toLowerCase();
    return field.formFieldValueTypeId === FormFieldValueTypeEnum.PhoneNumber
        || field.formFieldKeySpecialTypeId === CONTACT_PHONE_SPECIAL_TYPE
        || name.includes("phone");
}

export function formatIrishPhone(value: string) {
    const trimmed = value.trim();
    const international = trimmed.startsWith("+") || trimmed.startsWith("00");
    let digits = value.replace(/\D/g, "");
    if (digits.startsWith("00353"))
        digits = "0" + digits.slice(5);
    else if ((international && digits.startsWith("353")) || (digits.startsWith("353") && digits.length > 10))
        digits = "0" + digits.slice(3);
    return digits;
}
